import parse from 'html-react-parser';
import { showDate2 } from '.';
import { t } from 'i18next';
const columnCommonConfig = { sortable: false, width: 150 };

export const userTableColumns = [
  {
    field: 'name',
    headerName: 'common.name',
    ...columnCommonConfig,
    flex: 1,
    renderCell: ({ row }) => (row.firstName ? parse(row.firstName + ' ' + row.lastName) : '--'),
  },
  { field: 'email', headerName: 'Email', ...columnCommonConfig, flex: 1 },
  {
    field: 'phoneNumber',
    headerName: 'common.phone',
    ...columnCommonConfig,
    renderCell: ({ row }) => (row.phoneNumber ? row.phoneNumber : '-'),
    flex: 1,
  },
  {
    field: 'role',
    headerName: 'common.role',
    renderCell: ({ row }) => t(`labels.${row.role}`),
    ...columnCommonConfig,
    flex: 1,
  },
  {
    field: 'status',
    headerName: 'common.status',
    renderCell: ({ row }) => t(`labels.${row.status}`),
    ...columnCommonConfig,
    flex: 1,
  },
];

export const customerTableColumns = [
  {
    field: 'name',
    headerName: 'common.name',
    ...columnCommonConfig,
    flex: 1,
    renderCell: ({ row }) => parse(row.firstName + ' ' + row.lastName),
  },
  {
    field: 'email',
    headerName: 'Email',
    ...columnCommonConfig,
    flex: 1,
  },
  {
    field: 'phoneNumber',
    headerName: 'common.phone',
    ...columnCommonConfig,
    flex: 1,
  },
];
export const orderTableColumns = [
  {
    field: 'orderNumber',
    headerName: 'customerPage.orderId',
    ...columnCommonConfig,
    flex: 1,
  },
  {
    field: 'status',
    headerName: 'common.status',
    ...columnCommonConfig,
    renderCell: ({ row }) => {
      return t(`labels.${row.status[row.status.length - 1].status}`);
    },
    flex: 1,
  },
];

export const inventoryTableColumns = [
  {
    field: 'createdAt',
    headerName: 'customerPage.createdAt',
    ...columnCommonConfig,
    flex: 1,
    renderCell: ({ row }) => showDate2(row.createdAt),
  },
  {
    field: 'cement',
    headerName: 'inventoryPage.cement',
    ...columnCommonConfig,
    renderCell: ({ row }) => (row.cement ? row.cement : '-'),
    flex: 1,
  },
  {
    field: 'sand',
    headerName: 'inventoryPage.sand',
    ...columnCommonConfig,
    renderCell: ({ row }) => (row.sand ? row.sand : '-'),
    flex: 1,
  },
  {
    field: 'gravel815',
    headerName: 'inventoryPage.gravel815',
    ...columnCommonConfig,
    renderCell: ({ row }) => (row.gravel815 ? row.gravel815 : '-'),
    flex: 1,
  },
  {
    field: 'gravel1525',
    headerName: 'inventoryPage.gravel1525',
    ...columnCommonConfig,
    renderCell: ({ row }) => (row.gravel1525 ? row.gravel1525 : '-'),
    flex: 1,
  },
  {
    field: 'concrete',
    headerName: 'inventoryPage.concrete',
    ...columnCommonConfig,
    renderCell: ({ row }) => (row.concrete ? row.concrete : '-'),
    flex: 1,
  },
];

export const subOrderTableColumns = [
  {
    field: 'volumeOfConcrete',
    headerName: 'customerPage.volumeOfConcrete',
    ...columnCommonConfig,
    flex: 1,
  },
  {
    field: 'dosage',
    headerName: 'customerPage.dosage',
    ...columnCommonConfig,
    flex: 1,
  },
  {
    field: 'deliveryDate',
    headerName: 'customerPage.deliveryDate',
    ...columnCommonConfig,
    flex: 1,
    renderCell: ({ row }) => showDate2(row.deliveryDate),
  },
  {
    field: 'timeOfDelivery',
    headerName: 'customerPage.deliveryTime',
    ...columnCommonConfig,
    flex: 1,
    renderCell: ({ row }) => {
      return t(`labels.${row.timeOfDelivery}`);
    },
  },
  {
    field: 'deliveryAddress',
    headerName: 'common.deliveryAddress',
    ...columnCommonConfig,
    flex: 1,
    renderCell: ({ row }) =>
      row.streetAddress
        ? parse(row.streetNumber + ' ' + row.streetAddress + ' ' + row.municipality + ' ' + row.city)
        : '- - - -',
  },
];

export const banksTableColumns = [
  {
    field: 'bankName',
    headerName: 'bankDetails.bankName',
    ...columnCommonConfig,
    flex: 1,
  },
  {
    field: 'accountName',
    headerName: 'bankDetails.AccName',
    ...columnCommonConfig,
    flex: 1,
  },
  {
    field: 'accountNumber',
    headerName: 'bankDetails.AccNo',
    ...columnCommonConfig,
    flex: 1,
  },
];
